module.exports = __webpack_public_path__ + "static/media/diagrama.3f841e02.png";